import Service from "../../../Services/index";

const CheckList = {
    namespaced: true,
    state: {
        table: [],
        show_checklist:[],
        dataPaginate:{
            current_page :1,
            from : 1,
            last_page : 1,
            per_page : 1,
            total : 1,
            to : 1
        }
    },
    mutations: {
        GET_CHECKLIST: (state, res) => {
            state.table = res.data;
            state.dataPaginate = {
                current_page : res.current_page,
                from : res.form,
                last_page : res.last_page,
                per_page : res.per_page,
                total : res.total,
                to : res.to
            };
        },
        GET_CHECKLIST_BY_ID: (state, res) => {
            state.show_checklist = res;
        }
    },
    actions: {
        get({ commit },page=1) {
            return Service.CheckList.getCheckList(page).then(response => {
                commit("GET_CHECKLIST", response);
            });
        },
        create({commit},data) {
            return Service.CheckList.createCheckList(data);
        },
        show({commit},id){
            return Service.CheckList.getCheckListByID(id).then(response=>{
                commit("GET_CHECKLIST_BY_ID",response)
            })
        },
        update({commit},{id,data}){
            return Service.CheckList.updateCheckList(id,data);
        },
        search({commit},{page="",material_id,date}){
            return Service.CheckList.searchCheckList(page,material_id,date)
                .then(data=>{
                    commit("GET_CHECKLIST",data)
                });
        }
    }
};

export default CheckList;
